import axios from '@/libs/api.request'
import Qs from 'qs'
// 获取活动列表
export const getActivityList = (params) => {
    return axios.request({
        url: 'activity',
        method: 'get',
        params: params
    })
}

// 获取活动详情
export const getActivityDetails = (params) => {
    return axios.request({
        url: `activity/${params.id}`,
        method: 'get'
    })
}

// 活动报名表单
export const activityCreateForm = (params) => {
    return axios.request({
        url: 'activity_user/create',
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            // 请求数据前，对数据处理
            for (var key in data) {
                if (!data[key]) {
                    // console.log('1ed3w',data[key]);
                    if (data[key] != 0) {
                        delete data[key]
                    }
                    
                }
            }
            // console.log('请求的参数', data)
            data = Qs.stringify(data)
            return data
        }]
    })
}

// 活动签到
export const activitySign = (params) => {
    return axios.request({
        url: 'activity_user/update',
        method: 'post',
        data: params
    })
}

// 链接跳转打标签
export const createTagForUser = (params) => {
    return axios.request({
        url: 'activity_user/createTagForUser',
        method: 'post',
        data: params
    })
}

// 获取隐私条款
export const getPricacy = (params) => {
    return axios.request({
        url: '/policy',
        method: 'get',
    })
}

// 获取填写过的表单数据(进行默认字段填充)
export const getOldActivity = (params) => {
    return axios.request({
        url: '/activity_user/last',
        method: 'get',
        params: params
    })
}
// 获取验证码
export const getPhoneCode = (params) => {
    return axios.request({
        url: '/sms/send',
        method: 'post',
        data: params
    })
}